// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YPhGh4zI_JoqJNsyFapd{background:rgba(0,0,0,0);border:0;box-sizing:content-box;cursor:pointer;fill:#bed1cf;height:18px;padding:15px;position:absolute;right:10px;top:3px;width:14px;z-index:1040}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"closeButton": `YPhGh4zI_JoqJNsyFapd`
};
export default ___CSS_LOADER_EXPORT___;
